import type { ComponentType } from 'react';
import { hooks } from '@eon/api-client';
import { isOrgOperator, isSystemAdmin } from '@eon/types';
import { ForbiddenPage } from '../pages/ForbiddenPage';

interface RoleSwitchProps {
  admin: ComponentType;
  portal: ComponentType;
}

export function RoleSwitch({ admin: Admin, portal: Portal }: RoleSwitchProps) {
  const me = hooks.useMe();

  if (me.isLoading) {
    return null;
  }

  if (isSystemAdmin(me.data?.role)) {
    return <Admin />;
  }

  if (isOrgOperator(me.data?.role)) {
    return <Portal />;
  }

  return <ForbiddenPage />;
}
